<script lang="ts" setup>
  import { onMounted, ref, useSlots } from 'vue';

  const syncedSlotNames = ref<Array<string>>([]);

  onMounted(() => {
    syncedSlotNames.value = [];
    const slots = useSlots();
    for (const key of Object.keys(slots)) {
      if (key.indexOf("synced-input-") === 0) syncedSlotNames.value.push(key);
    }
  })
</script>

<template>
  <div class="layout layout--stacked">
    <div><slot name="label"></slot></div>
    <div><slot name="user-input"></slot></div>
    <div><slot name="keywords"></slot></div>
    <div class="print--hide"><slot name="previous-input"></slot></div>
    <div v-for="(syncedSlot, index) in syncedSlotNames" v-bind:key="index" class="print--hide"><slot v-bind:name="syncedSlot"></slot></div>
    <div><slot name="more-button"></slot></div>
  </div>
</template>
